import { render, staticRenderFns } from "./DotsVerticalSolid.vue?vue&type=template&id=12dbc646&"
import script from "./DotsVerticalSolid.vue?vue&type=script&lang=ts&"
export * from "./DotsVerticalSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports